import { useQuery } from '@tanstack/react-query';
import api from '../../api/api';
import { useWebLocale } from '../../contexts/WebLocaleContext';
export function useEvents(home = false) {
  const { locale } = useWebLocale();
  return useQuery({
    queryKey: ['public-events', home ? 'home' : 'list', locale],
    queryFn: async ({ signal }) => {
      const response = await api.getPublic(`/ads/events${home ? '/home' : ''}`, {
        signal,
        params: { locale },
        timeout: 15000,
        suppressGlobalError: true,
      });
      const value = response.data?.data;
      if (
        home
          ? typeof value?.enabled !== 'boolean' || !Array.isArray(value.events)
          : !Array.isArray(value)
      )
        throw new Error('Invalid events response');
      return value;
    },
    staleTime: 60000,
    // Native Home refreshes on returning after a minute, not every minute
    // while the reader stays on the page. Keep the dedicated list policy.
    refetchInterval: home ? false : 60000,
    ...(home ? { refetchOnWindowFocus: true } : {}),
    retry: 1,
  });
}
export function visibleEvents(data, home = false) {
  if (home && data?.enabled !== true) return [];
  const items = home ? data?.events : data;
  return Array.isArray(items) ? items.filter((item) => item.isActive !== false) : [];
}
